export default __webpack_public_path__ + "static/media/mail.e40333f6.svg";